import React, {FC} from "react";
import Link from "next/link";
import cls from "./posts.module.scss"
import Image from "next/image";
import {IPostCategory} from "../../types/posts";
import {TranslationsType} from "../../types/homePageTypes";
import {createRightDate} from "../../services/utils";

interface IProps {
    post: { image: string, rightDay: string, slug: string, name: string, published_at: string, created_at: string };
    category: IPostCategory;
    translationsData: TranslationsType;
    date_checked: boolean;
    read_more_checked: boolean
}

const PostCard: FC<IProps> = (
    {
        post: { rightDay, image, slug, name, published_at, created_at },
        category,
        translationsData,
        date_checked,
        read_more_checked
    }
) => {

    let postDate = rightDay ? rightDay : published_at ? createRightDate(published_at) : createRightDate(created_at)

    return (
        <Link href={`/posts/${category?.slug}/${slug}`}>
            <a>
                <div className={cls.postCard}>
                    <div className={cls.post_card_image}>
                        <Image
                            src={image}
                            alt={name}
                            layout="fill"
                            loading="lazy"
                            // priority
                        />
                    </div>
                    <div className={cls.post_card_info}>
                        <div className={cls.post_card_name}>
                            <h2>{name}</h2>
                        </div>
                        {!date_checked && !read_more_checked ? null : (
                            <div className={cls.post_card_read_data}>
                                {date_checked ? <div className={cls.post_card_date}>{postDate}</div> : null}
                                {read_more_checked ? <div className={cls.post_card_read_more}>
                                    {translationsData?.ReadMore}
                                </div> : null}
                            </div>
                        )}
                    </div>
                </div>
            </a>
        </Link>
    );
};

export default PostCard;